import debounce from 'lodash.debounce'
import { parseLink } from '@/services/parselinkService'

export default {
  data() {
    return {
      isOpen: false,
      localeName: '&nbsp;',
    }
  },

  computed: {
    getLocaleName() {
      const locale = this.availableLocales.find(locale => locale.code === this.getLocale)

      return locale.name
    },

    getLocale() {
      return this.$i18n.locale
    },

    availableLocales() {
      return this.$i18n.locales
    },
  },

  mounted() {
    this.$nextTick(() => {
      this.localeItems = this.$refs.items
      this.amoutOfLocaleItems = this.localeItems.childElementCount
      this.firstLocaleItem = this.localeItems.firstChild

      window.addEventListener('keyup', this.keyup)
      window.addEventListener('resize', this.resize)
      window.dispatchEvent(new Event('resize'))
      this.localeName = this.getLocaleName
    })
  },

  beforeDestroy() {
    window.removeEventListener('keyup', this.keyup)
    window.removeEventListener('resize', this.resize)
  },

  methods: {
    resize(e) {
      this.resizeDebounce(e, this)
    },

    resizeDebounce: debounce(function (e) {
      const localeItemHeight = this.firstLocaleItem.offsetHeight

      this.heightOfCloseItems = localeItemHeight
      this.heightOfOpenItems = this.amoutOfLocaleItems * localeItemHeight

      this.close()
    }, 100),

    open() {
      this.isOpen = this.availableLocales.length > 1
    },

    close() {
      this.isOpen = false
    },

    keyup(e) {
      if (e.keyCode === 27 && this.isOpen) this.close()
    },

    parseLink(payload) {
      const { path, locale } = payload

      const route = locale ? `${this.switchLocalePath(locale)}` : path

      const newUrl = parseLink(route)

      return newUrl
    },
  },
}
